import { jsx as o } from "react/jsx-runtime";
import { ReadMore as t } from "../ReadMore/index.js";
import { useTranslation as i } from "../../hooks/useTranslation.js";
import { READMORE_CHAR_CUTOFF as m } from "../../constants/index.js";
const a = ({ content: r }) => {
  const { t: e } = i();
  return r.length > m ? /* @__PURE__ */ o(
    t,
    {
      numberOfLines: 4,
      openText: e("show_everything"),
      closeText: e("hide"),
      fade: !0,
      children: r
    }
  ) : /* @__PURE__ */ o("p", { children: r ?? "" });
};
export {
  a as ReadMoreWrapper
};
